import AssetsBrowser from "../AssetsBrowser";

export default function AssetsBrowserModal({
  onClose,
  header = "Find Assets",
  tags = [],
  showUntagged = false,
  mediaType = "",
  multiSelect = false,
}) {
  return (
    <div className="h-full w-full max-w-[600px] max-h-[720px] rounded-md flex flex-col bg-background border">
      <div className="flex-1 overflow-hidden">
        <AssetsBrowser
          onSelect={(asset) => onClose(asset)}
          tags={tags}
          showUntagged={showUntagged}
          header={header}
          mediaType={mediaType}
          multiSelect={multiSelect}
          onClose={onClose}
        />
      </div>
    </div>
  );
}
